// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SettingContainer__settingsContainer___XgXXf {
    display: grid;
    grid-template-columns: 10rem 18.8rem;
    gap: var(--space-xs);
    align-items: center;
}

.SettingContainer__rowContainer___to_9q {
    display: flex;
    gap: var(--space-xs);
}
`, "",{"version":3,"sources":["webpack://./../GM.Frontend.Library/src/model/Actions/CommonRenderers/Settings/SettingsBlock/SettingContainer.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,oCAAoC;IACpC,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,oBAAoB;AACxB","sourcesContent":[".settingsContainer {\n    display: grid;\n    grid-template-columns: 10rem 18.8rem;\n    gap: var(--space-xs);\n    align-items: center;\n}\n\n.rowContainer {\n    display: flex;\n    gap: var(--space-xs);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"settingsContainer": `SettingContainer__settingsContainer___XgXXf`,
	"rowContainer": `SettingContainer__rowContainer___to_9q`
};
export default ___CSS_LOADER_EXPORT___;
